import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import productReducer from './slices/product-slice';
import currencyReducer from "./slices/currency-slice";
import cartReducer from "./slices/cart-slice";
import compareReducer from "./slices/compare-slice";
import wishlistReducer from "./slices/wishlist-slice";
import pacienteReducer from "./slices/paciente-slice"
import modalidadReducer from "./slices/modalidad-slice"
import bioequivalenteSlice from './slices/bioequivalente-slice';
import userSlice from './slices/user-slice';
import direccionesSlice from './slices/direcciones-slice';
import registroSlice from './slices/registro-slice';
import documentosSlice from './slices/documentos-slice';
import recetasSlice from './slices/recetas-slice';

const persistConfig = {
    key: "vo2_3",
    version: 2.3,
    storage,
};

export const rootReducer = combineReducers({
    product: productReducer,
    currency: currencyReducer,
    cart: cartReducer,
    compare: compareReducer,
    wishlist: wishlistReducer,
    paciente: pacienteReducer,
    modalidad: modalidadReducer,
    bioequivalente: bioequivalenteSlice,
    user: userSlice,
    direcciones: direccionesSlice,
    registro: registroSlice,
    documentos: documentosSlice,
    recetas: recetasSlice
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    FLUSH,
                    REHYDRATE,
                    PAUSE,
                    PERSIST,
                    PURGE,
                    REGISTER,
                ],
            },
        }),
    
});

export const persistor = persistStore(store);